/**
 * Canonieke Kleda contact- en registratiegegevens (SSOT §1).
 */
export const KLEDA_CONTACT = {
  /** Weergave-notatie: met spaties, zonder streepje (SSOT §6B) */
  telefoonWeergave: '088 299 9277',
  /** Voor tel:-links */
  telefoonTel: '+31882999277',
  email: 'info@kleda.nl',
  website: 'https://kleda.nl',
  /** Bevestigd door Willem 10 jun 2026 — "13" zonder a is fout */
  adres: 'Oeveraseweg 13a, 7971PA Havelte',
  /** Bevestigd door Willem 10 jun 2026 — 01117291 is fout */
  kvk: '04061759',
  klantenservice: 'ma–vr 09:00–13:00',
} as const
